export default __webpack_public_path__ + "static/media/th.63b2c2b0.jpg";